/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthBrowserModule } from '@fleetmatics/ui.authentication';
import { HelpPanelModule } from '@fleetmatics/ui.help-panel';
import { HelpPanelConnectorModule } from '@fleetmatics/ui.help-panel/connector';
import { CookieBannerConnectorModule } from '@fleetmatics/ui.utilities/cookie-banner-connector';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../environments/environment';
import { AppIconModule } from './app-icon.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_CONFIG } from './core/config/app-config.token';
import { BUILD_TIMESTAMP } from './core/config/build-timestamp.token';
import { CoreModule } from './core/core.module';
import { IUserSettings } from './core/models';
import { USER_SETTINGS_TOKEN } from './core/tokens/user-settings.token';
import { HammerConfig } from './hammer.config';
import { LazyLoaderModule } from './lazy-loader/lazy-loader.module';

export const DATE_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY'
  }
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthBrowserModule.forRoot(environment.config, { appHandlesForbidden: true }),
    MatIconModule,
    AppIconModule,
    MatSidenavModule,
    CoreModule,
    LazyLoaderModule,
    HelpPanelModule.forRoot(environment.config),
    HelpPanelConnectorModule.forRoot(() => import('../lazy-components/help-panel-wrapper.component')),
    MatLegacySnackBarModule,
    CookieBannerConnectorModule.forRoot(() => import('../lazy-components/cookie-banner-wrapper.component'))
  ],
  providers: [
    { provide: APP_CONFIG, useValue: environment.config },
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
    { provide: USER_SETTINGS_TOKEN, useValue: new BehaviorSubject<IUserSettings>(null) },
    { provide: BUILD_TIMESTAMP, useValue: environment.buildTimestamp },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
